import React, { useState } from "react"

import { graphql, useStaticQuery } from "gatsby"
import PropTypes from "prop-types"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

import * as styles from "./button-group.module.scss"
import Button from "../../atoms/button"
import Grouping from "../../atoms/grouping"
import SubscribeFirst from "../subscribe-first"

const ButtonGroup = ({
  ctas,
  alignment,
  external,
  variant,
  large,
  gatingVertical,
  gatingTitle,
  gatingCopy,
  gatingButtonText,
}) => {
  const { allSanitySubscribe, allSanityDictionary } = useStaticQuery(graphql`
    {
      allSanityDictionary {
        nodes {
          key {
            current
          }
          value
        }
      }
      allSanitySubscribe {
        nodes {
          vertical {
            cm_id
            slug {
              current
            }
            color
          }
          illustration {
            default {
              image {
                ...ImageWithPreview
              }
            }
          }
        }
      }
    }
  `)
  const [subscribed, setSubscribed] = useState("")
  const currentSubscribe =
    allSanitySubscribe.nodes.find(
      (subscribe) => subscribe.vertical.slug.current === gatingVertical
    ) ||
    allSanitySubscribe.nodes.find(
      (subscribe) => subscribe.vertical.slug.current === "daily-sports"
    )

  const trackSubscribed = () => {
    localStorage.setItem(
      `subscribed_${currentSubscribe?.vertical.slug.current || "daily-sports"}`,
      true
    )
    setSubscribed(true)
  }

  return gatingVertical && !subscribed ? (
    <div
      className={`${styles.subscribe} ${
        styles[`bottom__${currentSubscribe?.vertical.color || "cobalt"}`]
      }`}
    >
      <div className={styles.subscribeWrapper}>
        <GoogleReCaptchaProvider
          reCaptchaKey={process.env.GATSBY_RECAPTCHA_KEY}
        >
          <SubscribeFirst
            changeStep={trackSubscribed}
            gating
            illustration={currentSubscribe?.illustration.default?.image}
            data={{
              ...currentSubscribe,
              heading: {
                default: gatingTitle,
              },
              description: {
                _rawDefault: gatingCopy,
              },
              ctas: {
                cta:
                  gatingButtonText ||
                  allSanityDictionary.nodes.find(
                    (item) => item.key.current === "subscribe_gated"
                  )?.value,
              },
            }}
          />
        </GoogleReCaptchaProvider>
      </div>
      <div className={styles.subscribeBottom}>
        <button
          className={styles.subscribeAlready}
          type="button"
          aria-label="subscribe"
          onClick={trackSubscribed}
          onKeyPress={trackSubscribed}
        >
          {
            allSanityDictionary.nodes.find(
              (item) => item.key.current === "subscribe_already"
            )?.value
          }
        </button>
      </div>
    </div>
  ) : (
    <Grouping
      className={`${styles.buttons} ${styles[`buttons__${alignment}`]}`}
    >
      {ctas.map((cta) => (
        <Button
          url={cta.url}
          variant={cta.variant || variant}
          key={cta.url}
          target={external ? "_blank" : null}
          rel={external ? "noreferrer" : null}
          internal={!external}
          large={large}
        >
          {cta.text}
        </Button>
      ))}
    </Grouping>
  )
}

export default ButtonGroup

ButtonGroup.propTypes = {
  ctas: PropTypes.array.isRequired,
  alignment: PropTypes.string,
  external: PropTypes.bool,
  variant: PropTypes.string,
  large: PropTypes.bool,
  gatingVertical: PropTypes.string,
  gatingTitle: PropTypes.string,
  gatingCopy: PropTypes.object,
  gatingButtonText: PropTypes.string,
}

ButtonGroup.defaultProps = {
  alignment: "left",
  external: false,
  variant: "primary",
  large: false,
  gatingVertical: "",
  gatingTitle: "",
  gatingCopy: null,
  gatingButtonText: "",
}
